{
  "version": 1,
  "asset_id": "274e3310-b0cd-4858-955d-83d9c250407f",
  "project_id": "ede4779f-2e7a-461a-91d6-654024119c69",
  "url": "/__l5e/assets-v1/274e3310-b0cd-4858-955d-83d9c250407f/bartek-lalek.jpg",
  "r2_key": "a/v1/ede4779f-2e7a-461a-91d6-654024119c69/274e3310-b0cd-4858-955d-83d9c250407f/bartek-lalek.jpg",
  "original_filename": "bartek-lalek.jpg",
  "size": 29634,
  "content_type": "image/jpeg",
  "created_at": "2026-09-14T17:14:52Z"
}
